import { useEffect } from 'react';
import { useIncomingCall } from '../contexts/IncomingCallContext';
import { useNavigate } from 'react-router-dom';

/**
 * Component to listen for messages from service worker
 * Add this to your main App component INSIDE <Router>
 */
const ServiceWorkerListener = () => {
  const incomingCallContext = useIncomingCall();
  
  // Use optional chaining for safety
  const showIncomingCall = incomingCallContext?.showIncomingCall;
  const handleEndCall = incomingCallContext?.handleEndCall;
  
  // Always call the hook - hooks must be called unconditionally
  const navigate = useNavigate();

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Listen for messages from service worker
      const messageHandler = (event) => {
        console.log('📨 Message from service worker:', event.data);

        if (event.data && event.data.type) {
          switch (event.data.type) {
            case 'ACCEPT_CALL':
              console.log('✅ Processing call acceptance from notification');
              if (event.data.data && showIncomingCall) {
                showIncomingCall({
                  callerName: event.data.data.callerName || event.data.data.receiverName,
                  callerId: event.data.data.callerId,
                  channel: event.data.data.channelName,
                  userType: event.data.data.userType,
                  type: event.data.data.type
                });
              }
              break;

            case 'REJECT_CALL':
              console.log('❌ Call rejected from notification');
              if (handleEndCall) {
                handleEndCall();
              }
              break;

            case 'NOTIFICATION_CLICKED':
              console.log('🔔 Notification clicked');
              // Handle notification click - navigate to appropriate page
              try {
                if (event.data.data?.url) {
                  navigate(event.data.data.url);
                } else {
                  navigate('/notifications');
                }
              } catch (error) {
                console.error('Navigation error:', error);
                // Fallback if navigate fails
                const url = event.data.data?.url || '/notifications';
                window.location.href = url;
              }
              break;

            default:
              console.log('Unknown message type:', event.data.type);
          }
        }
      };

      navigator.serviceWorker.addEventListener('message', messageHandler);

      return () => {
        navigator.serviceWorker.removeEventListener('message', messageHandler);
      };
    }
  }, [showIncomingCall, handleEndCall, navigate]);

  return null; // This component doesn't render anything
};

export default ServiceWorkerListener;